export default __webpack_public_path__ + "media/trail/rotate-left-green-6ab14fbd.svg";